import { Map, Overlay, View } from "ol";
import { Zoom } from "ol/control";
import * as olExtent from "ol/extent";
import ImageLayer from "ol/layer/Image";
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";
import { fromLonLat, Projection } from "ol/proj";
import { ImageStatic } from "ol/source";
import OSM from "ol/source/OSM";
import "src/css/map.css";

import { formatterImageCoordsToExtent } from "src/api/map/formatter";
import { Interface_Map_Init_Params } from "src/types/map";

export const osmMap = (params: Interface_Map_Init_Params): Map => {
    const { data, target, vectorSource } = params;
    const extent = fromLonLat(data.bound[0]).concat(fromLonLat(data.bound[1]));

    return new Map({
        target: target,
        layers: [
            new TileLayer({
                source: new OSM({
                    url: data.url,
                }),
                className: "ol_bw",
            }),
            new VectorLayer({
                source: vectorSource,
            }),
        ],
        view: new View({
            center: sessionStorage.getItem("currentCenter")
                ? JSON.parse(sessionStorage.getItem("currentCenter")!)
                : olExtent.getCenter(extent),
            zoom: sessionStorage.getItem("currentZoom")
                ? parseFloat(sessionStorage.getItem("currentZoom")!)
                : data.minZoom,
            extent: extent,
            minZoom: data.minZoom,
            maxZoom: data.maxZoom,
        }),
        controls: [
            new Zoom({
                className: "zoom-handlers",
            }),
        ],
    });
};

export const staticImageMap = (params: Interface_Map_Init_Params): Map => {
    const { data, target, vectorSource } = params;

    const imageExtent = formatterImageCoordsToExtent(data.bound);
    const projection = new Projection({
        code: "img-map",
        units: "pixels",
        extent: imageExtent,
    });

    return new Map({
        target: target,
        layers: [
            new ImageLayer({
                source: new ImageStatic({
                    url: data.url,
                    projection: projection,
                    imageExtent: imageExtent,
                }),
            }),
            new VectorLayer({
                source: vectorSource,
            }),
        ],
        view: new View({
            projection: projection,
            center: sessionStorage.getItem("currentCenter")
                ? JSON.parse(sessionStorage.getItem("currentCenter")!)
                : olExtent.getCenter(imageExtent),
            zoom: sessionStorage.getItem("currentZoom")
                ? parseFloat(sessionStorage.getItem("currentZoom")!)
                : data.minZoom,
            maxZoom: data.maxZoom,
            minZoom: data.minZoom,
            extent: imageExtent,
        }),
        controls: [
            new Zoom({
                className: "zoom-handlers",
            }),
        ],
    });
};

export const setOverlayPositionToBottom = (
    overlay: Overlay,
    mapInstance: Map,
) => {
    const view = mapInstance.getView();
    const extent = view.calculateExtent(mapInstance.getSize());

    const centerX = (extent[0] + extent[2]) / 2;
    const bottomY = extent[1];

    overlay.setPosition([centerX, bottomY]);
    overlay.setPositioning("bottom-center");
};
